import { TutorialProvider, useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { hocs as pageHocs } from 'modules/page';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { PageContent } from '../components/PageContent/PageContent';
import PageSkeleton from '../components/PageContent/PageSkeleton';
import { COMPANY_REQUESTS_LIST_PAGE_ID, PAGE_ID } from '../config';
import { starterGuideActionsClass } from '../constants';
import PageError from '../containers/PageError/PageError';
import useCompanyRequestsListPageData from '../hooks/useCompanyRequestsListPageData';
import { useLeavePage } from '../hooks/useLeavePage';
import { messages } from './CompanyRequestsListPage.messages';

export const CompanyRequestsListPage: FC = () => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(selectors.navigation.getInnerActivePageId);

    useLayout({ hasHeader: true, hasDrawer: true });
    useLeavePage();

    const { isInitialLoading, isError } = useCompanyRequestsListPageData();

    if (isError) {
        return <PageError />;
    }

    if (isInitialLoading || activePageId !== PAGE_ID || innerActivePageId !== COMPANY_REQUESTS_LIST_PAGE_ID) {
        return <PageSkeleton />;
    }

    return (
        <TutorialProvider
            selector={`.${starterGuideActionsClass}`}
            content={messages.tutorialContent({
                br: <br />,
            })}
        >
            {({ openTour }) => <PageContent requestListPage='company' openTour={openTour} />}
        </TutorialProvider>
    );
};

export default pageHocs.withProtected({ Page: CompanyRequestsListPage });
